import { NodeProps } from 'reactflow';
import { LeafEndNodeData } from 'assets/js/pages/engage/workflows/actions/types';
import * as CanvasNode from 'assets/js/pages/engage/workflows/components/CanvasNode';

interface LeafEndProps extends NodeProps<LeafEndNodeData> {}
const LeafEnd = ({ id }: LeafEndProps) => {
    return (
        <CanvasNode.Root isSelected={false} isError={false} id={id}>
            <CanvasNode.Container className="flex min-w-80 cursor-default flex-col items-center border-0 bg-transparent shadow-none hover:shadow-none md:min-w-80">
                <CanvasNode.Body className="flex items-center justify-center rounded-full border border-gray-300 bg-white px-3 py-2">
                    <span className="text-sm font-medium text-gray-900">END</span>
                </CanvasNode.Body>
            </CanvasNode.Container>
        </CanvasNode.Root>
    );
};

export { LeafEnd };
export type { LeafEndProps };
